
<template>
  <div id="app" class="notranslate" translate="no">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html {
  height:100%
}
#app {
  font-family: Helvetica;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin: 0px;
  height:100%;
}
body {
  margin: 0px;
  height:100%;
}
</style>
